import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaTrash, FaList } from 'react-icons/fa';
import { toast } from 'react-toastify';
import bankService from '../services/bankService';

const BankAccountsPage = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAccounts = async () => {
    try {
      const data = await bankService.getAllAccounts();
      setAccounts(data);
    } catch (error) {
      toast.error('Banka hesapları yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Bu banka hesabını silmek istediğinize emin misiniz?')) {
      try {
        await bankService.deleteAccount(id);
        toast.success('Hesap silindi.');
        fetchAccounts();
      } catch (error) {
        toast.error('Silme işlemi başarısız.');
      }
    }
  };

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Banka Hesapları</h2>
        <Link to="/banks/new" className="btn btn-primary">
          <FaPlus className="me-2" /> Yeni Hesap Ekle
        </Link>
      </div>

      <div className="row">
        {accounts.map((account) => (
          <div key={account.id} className="col-md-6 mb-4">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title text-primary">{account.bank_name}</h5>
                <h6 className="card-subtitle mb-2 text-muted">{account.branch_name}</h6>
                <p className="card-text">
                  <strong>IBAN:</strong> {account.iban}<br />
                  <strong>Hesap No:</strong> {account.account_number}<br />
                  <strong>Döviz:</strong> {account.currency}
                </p>
                <div className="d-flex justify-content-end">
                  <Link to={`/banks/detail/${account.id}`} className="btn btn-outline-info btn-sm me-2">
                    <FaList className="me-1" /> Hareketler
                  </Link>
                  <button onClick={() => handleDelete(account.id)} className="btn btn-outline-danger btn-sm">
                    <FaTrash className="me-1" /> Sil
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        {accounts.length === 0 && (
          <div className="col-12">
            <div className="alert alert-info">Kayıtlı banka hesabı bulunamadı.</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BankAccountsPage;